import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header, Footer } from '../components/HomePage';
import CookiePolicy from '../components/HomePage/Footer/CookiePolicy';

function CookiePolicyPage() {
  return (
    <>
      <Helmet>
        <title>Cookie Policy | Circledin - Cookie and Tracking Technology Information</title>
        <meta 
          name="description" 
          content="Read Circledin's Cookie Policy. Learn how we use cookies and tracking technologies to improve your experience on our mobile plan sharing platform." 
        />
        <meta name="keywords" content="cookie policy, cookies, tracking, web analytics, user experience, privacy, circledin, mobile plans, data collection, browser storage" />
        <meta name="robots" content="index, follow" />
        
        {/* Open Graph meta tags */}
        <meta property="og:title" content="Cookie Policy | Circledin - Cookie and Tracking Technology Information" />
        <meta property="og:description" content="Learn how Circledin uses cookies and tracking technologies to enhance your browsing experience and improve our services." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://circledin.com/cookie-policy" />
        
        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Cookie Policy | Circledin - Cookie and Tracking Technology Information" />
        <meta name="twitter:description" content="Learn how Circledin uses cookies and tracking technologies to enhance your browsing experience and improve our services." />
        
        {/* Additional Cookie Policy-Specific Meta Tags */}
        <meta name="cookie-policy" content="https://circledin.com/cookie-policy" />
        <meta name="cookie-consent" content="granular consent available" />
        <meta name="tracking-technologies" content="cookies, web beacons, analytics" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://circledin.com/cookie-policy" />
        
        {/* Additional SEO Meta Tags */}
        <meta name="author" content="Circledin, Inc." />
        <meta name="publisher" content="Circledin, Inc." />
        <meta name="copyright" content="© 2025 Circledin, Inc." />
        <meta name="language" content="EN" />
        <meta name="revisit-after" content="30 days" />
        
        {/* Schema.org Structured Data for Cookie Policy */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Cookie Policy",
            "description": "Circledin's Cookie Policy explaining how we use cookies and tracking technologies on our platform.",
            "url": "https://circledin.com/cookie-policy",
            "inLanguage": "en-US",
            "isPartOf": {
              "@type": "WebSite",
              "name": "Circledin",
              "url": "https://circledin.com"
            },
            "author": {
              "@type": "Organization",
              "name": "Circledin, Inc.",
              "url": "https://circledin.com"
            },
            "datePublished": "2025-01-01",
            "dateModified": "2025-01-01",
            "mainEntity": {
              "@type": "DigitalDocument",
              "name": "Circledin Cookie Policy",
              "description": "Comprehensive cookie policy detailing our use of cookies, tracking technologies, and user privacy controls.",
              "version": "1.0",
              "datePublished": "2025-01-01",
              "author": {
                "@type": "Organization",
                "name": "Circledin, Inc."
              },
              "about": [
                {
                  "@type": "Thing",
                  "name": "HTTP Cookies"
                },
                {
                  "@type": "Thing", 
                  "name": "Web Analytics"
                },
                {
                  "@type": "Thing",
                  "name": "User Privacy"
                },
                {
                  "@type": "Thing",
                  "name": "Data Protection"
                },
                {
                  "@type": "Thing",
                  "name": "Tracking Technologies"
                }
              ],
              "keywords": "cookies, tracking, privacy, data collection, user consent, web analytics, browser storage, third-party services"
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://circledin.com"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Cookie Policy",
                  "item": "https://circledin.com/cookie-policy"
                }
              ]
            }
          })}
        </script>
        
        {/* Cookie Consent and Privacy-Related Meta Tags */}
        <meta name="cookie-categories" content="essential, analytics, functional, marketing" />
        <meta name="data-retention" content="varies by cookie type" />
        <meta name="user-control" content="cookie preferences available" />
        <meta name="gdpr-compliant" content="yes" />
        <meta name="ccpa-compliant" content="yes" />
        
        {/* Technical Cookie Information */}
        <meta name="first-party-cookies" content="authentication, preferences, security" />
        <meta name="third-party-cookies" content="analytics, advertising, social media" />
        <meta name="cookie-management" content="browser settings, opt-out tools available" />
      </Helmet>
      
      <Header />
      <CookiePolicy />
      <Footer />
    </>
  );
}

export default CookiePolicyPage;